import React from 'react';
import { CheckIcon, LayersIcon } from 'lucide-react';
interface ProductCardProps {
  product: {
    id: string;
    name: string;
    brand: string;
    image: string;
    variants: any[];
  };
  isSelected: boolean;
  onToggleSelect: () => void;
}
export const ProductCard: React.FC<ProductCardProps> = ({
  product,
  isSelected,
  onToggleSelect
}) => {
  return <div className={`bg-white border rounded-md overflow-hidden transition-all ${isSelected ? 'border-blue-500 shadow-md' : 'border-gray-200 hover:border-blue-300'}`} data-id="element-178">
      <div className="relative" data-id="element-179">
        <div className="h-40 p-4 flex items-center justify-center" data-id="element-180">
          <img src={product.image} alt={product.name} className="max-h-full object-contain" data-id="element-181" />
        </div>
        {isSelected && <div className="absolute top-2 right-2 bg-blue-500 text-white rounded-full h-6 w-6 flex items-center justify-center" data-id="element-182">
            <CheckIcon className="h-4 w-4" data-id="element-183" />
          </div>}
      </div>
      <div className="p-4 border-t border-gray-100" data-id="element-184">
        <div className="text-xs text-gray-500 mb-1" data-id="element-185">{product.brand}</div>
        <h3 className="font-medium text-gray-800 mb-1 truncate" data-id="element-186">
          {product.name}
        </h3>
        <div className="flex items-center text-sm text-gray-600 mb-3" data-id="element-187">
          <LayersIcon className="h-4 w-4 mr-1 text-gray-400" data-id="element-188" />
          <span data-id="element-189">{product.variants.length} variants available</span>
        </div>
        {/* Variant preview thumbnails */}
        <div className="flex flex-wrap gap-1 mb-3" data-id="element-190">
          {product.variants.slice(0, 4).map(variant => <div key={variant.id} className="w-6 h-6 bg-gray-100 rounded border border-gray-200 flex items-center justify-center text-xs text-gray-500 overflow-hidden" title={variant.name} data-id="element-191">
              {variant.sku.substring(0, 2)}
            </div>)}
          {product.variants.length > 4 && <div className="w-6 h-6 bg-gray-100 rounded border border-gray-200 flex items-center justify-center text-xs text-gray-500" data-id="element-192">
              +{product.variants.length - 4}
            </div>}
        </div>
        <button onClick={onToggleSelect} className={`w-full py-2 rounded-md font-medium text-sm ${isSelected ? 'bg-blue-50 text-blue-600 border border-blue-200' : 'bg-blue-600 text-white hover:bg-blue-700'}`} data-id="element-193">
          {isSelected ? 'Added' : 'Add Product Line'}
        </button>
      </div>
    </div>;
};